import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';
import moment from 'moment';
const ListPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    const mapKey = props.performance.specialFeature?.toLowerCase().trim();
    const specialFeatureMapping = props.specialFeatureMap?.get(mapKey) || null;

    return (
        <li className="ace-production-row stack-sm-mobile">
            <p className="ace-production-info ace-production-info-split">
                <span className="bold">
                    {specialFeatureMapping &&
                        <span>{`${specialFeatureMapping.symbol}`}</span>
                    }
                    {moment(props.performance.date).format('ddd, MMM D, YYYY')}</span>
                <span>{props.performance.performanceTimeString}</span>
                <span>{props.performance.specialFeature}</span>
            </p>
            {
                props.showReserveButton ?
                    <p className="ace-production-cta">
                        <button data-perf={props.performance.performanceId} className={'btn-wide btn-primary'} disabled={!props.performanceInCart && !props.allowReserve} onClick={() => {
                            if (props.performanceInCart) {
                                props.removeFromCart(props.performance.performanceId);
                            } else {
                                props.selectPerformance(props.performance, props.useUnSeatedReservation);
                            }
                        }}>
                            {props.performanceInCart ? props.text.removeButtonText : props.text.addToCartButtonText}
                        </button>
                    </p>
                    : null
            }

        </li>
    );
}

export default ListPerformanceView;